<!-- Safe Compensation -->
<template>
  <div class="sc-list-page">
    <!-- 상단 검색 영역 -->
    <div class="search-area">
      <div class="search-row">
        <div class="info-label">차량번호</div>
        <input
          type="text"
          v-model="carNoSearch"
          placeholder="ex) 12*3456"
          class="search-input"
          />
          <!-- @input="filterCarNumber" -->
        <div class="info-label">전화번호</div>
        <input
          type="text"
          v-model="hpNoSearch"
          placeholder="ex) 010-1234-5678"
          class="search-input"
        />
        <button class="search-btn" @click="fetchList" :disabled="isLoading">
          {{ isLoading ? "조회 중..." : "조회" }}
        </button>
      </div>
    </div>
    <div class="main">
      <!-- AG Grid 테이블 -->
      <ag-grid-vue
        class="ag-sc-balham"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :gridOptions="gridOptions"
        :theme="theme"
        @grid-ready="onGridReady"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "CrListPage",
  components: {
    AgGridVue,
  },
  data() {
    return {
      userInfo: null, // 로그인한 사용자 정보

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        // rowHeight: 16,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      carNoSearch: "",
      hpNoSearch: "",
      isLoading: false, // 로딩 상태 추가
      gridApi: null,
      columnDefs: [
        {
          headerName: "",
          valueGetter: "node.rowIndex + 1",
          flex: 0.2,
          cellStyle: { textAlign: "center", backgroundColor: "#f0f0f0" },
        },
        {
          field: "SALE_DATE",
          headerName: "판매일자",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "VAN_BIZ_NO",
          headerName: "점번",
          flex: 0.5,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "SHOP_NM",
          headerName: "매장명",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "BILL_NO",
          headerName: "영수번호",
          flex: 0.5,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "PROD_NM",
          headerName: "상품명",
          flex: 2,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "SALE_FG_NM",
          headerName: "판매현황",
          flex: 0.5,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "CST_NM",
          headerName: "회원명",
          flex: 0.6,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "HP_NO",
          headerName: "핸드폰번호",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "CAR_NO",
          headerName: "차량번호",
          flex: 0.7,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "CAR_MODEL_NM",
          headerName: "차량명",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "L_ACC_KM",
          headerName: "보험가입km",
          flex: 0.6,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "SERVICE_FG_NM",
          headerName: "보험여부",
          flex: 0.6,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "SERVICE_COM_DATE",
          headerName: "D-Day",
          flex: 0.4,
          cellStyle: this.gridCellStyle,
        },
        {
          field: "SERVICE_DATE",
          headerName: "보험일자",
          flex: 0.7,
          cellStyle: this.gridCellStyle,
        },
      ],
      gridOptions: {
        headerHeight: 35,
        rowHeight: 25,
        suppressHorizontalScroll: false,
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        suppressNoRowsOverlay: false,
        overlayNoRowsTemplate: '<span style="padding: 10px; border: 1px solid #ccc; background: #f9f9f9;">조회된 데이터가 없습니다.</span>',
        tooltipShowMode: "whenTruncated",
        enableBrowserTooltips: false,
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          tooltipValueGetter: (params) => params.value,
          comparator: (valueA, valueB) => {
            const isANumber = !isNaN(parseFloat(valueA)) && isFinite(valueA);
            const isBNumber = !isNaN(parseFloat(valueB)) && isFinite(valueB);

            if (isANumber && isBNumber) {
              return valueA - valueB;
            }
            if (!isANumber && !isBNumber) {
              return String(valueA).localeCompare(String(valueB));
            }
            return isANumber ? -1 : 1;
          },
          resizable: true,
          headerStyle: {
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
      },
      rowData: [],
    };
  },
  watch: {
    
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
    },
    async fetchList() {
      if (this.isLoading) return;

      
      if (!this.carNoSearch && !this.hpNoSearch) {
        alert("차량번호 또는 핸드폰 번호둘중 하나는 입력하세요");
        return;
      }

      try {
        
        this.isLoading = true;
        const params = {
          carNo: this.carNoSearch,
          hpNo: this.hpNoSearch,
        };

        const response = await axios.get("/api/scListPage/fetchList", {
          params,
        });

        // AG Grid 데이터 업데이트
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          this.rowData = response.data;
        } else {
          this.rowData = [];
          alert("조회된 데이터가 없습니다.");
        }
      } catch (error) {
        console.error("데이터 조회 실패:", error);
        alert("데이터 조회 중 오류가 발생했습니다.");
      } finally {
        this.isLoading = false;
      }
    },
    filterCarNumber(event) {
      // 숫자와 '*'만 허용합니다.
      const filteredValue = event.target.value.replace(/[^0-9*]/g, "");
      this.carNoSearch = filteredValue;
    },
    
    gridCellStyle(params) {
      const style = {};
      const field = params.colDef.field;
      const centerAlignFields = [
        "SALE_DATE",
        "VAN_BIZ_NO",
        "SHOP_NM",
        "BILL_NO",
        "SALE_FG_NM",
        "CST_NM",
        "CAR_NO",
        "CAR_MODEL_NM",
        "SERVICE_FG_NM",
        "SERVICE_DATE",
      ];

      if (centerAlignFields.includes(field)) {
        style.textAlign = "center";
      } else if (field == "L_ACC_KM" || field == "SERVICE_COM_DATE") {
        style.textAlign = "right";
      } else {
        style.textAlign = "left";
      }

      return style;
    },
    validateDate(event) {
      const min = event.target.min;
      const max = event.target.max;
      const value = event.target.value;

      if (value) {
        if (value < min) {
          this.searchDate = min;
        } else if (value > max) {
          this.searchDate = max;
        }
      }
    },
  
  },
  mounted() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

  },
};
</script>

<style scoped>
.sc-list-page {
  font-family: "Malgun Gothic", sans-serif;
  padding: 10px 5px;
}

.search-area {
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f5f5f5;
}

.search-row {
  display: flex;
  /* gap: 10px; */
  justify-content: center; /* 시작점에서 정렬합니다. */
  width: 100%;
}

.search-row > * {
  font-family: Arial, sans-serif;
  font-size: 0.9rem;
}

.search-btn {
  padding: 0;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 10%;
}

.info-label {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background-color: #ffc080;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-input {
  border-radius: 4px;
  border: 1px solid;
}

:deep(.ag-sc-balham) {
  height: calc(100vh - 180px);
  --ag-cell-horizontal-padding: 3px; /* 셀 내부 좌우 패딩 */
}

:deep(.ag-header-cell) {
  background-color: #f0f0f0;
}

:deep(.ag-header-cell-label) {
  justify-content: center;
}

:deep(.ag-cell) {
  font-size: 0.8rem;
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-sc-balham .ag-cell) {
    font-size: 1rem;
  }
  .search-row > * {
    font-size: 1rem;
  }
}
</style>
